import { DASHBOARD_TODO_LIST_FEATURE_HINT_IDS, type DashboardTodoListFeatureHintId } from '#shared/lib/featureHints';

export const DASHBOARD_TODO_LIST_MAX_COMPLETED_ITEMS = 6;

export const DASHBOARD_TODO_LIST_HINT_COPY: Record<
    DashboardTodoListFeatureHintId,
    { title: string; caption?: string }
> = {
    [DASHBOARD_TODO_LIST_FEATURE_HINT_IDS.TITLE]: {
        title: 'Шаги для роста магазина',
        caption: 'Шаги, которые помогут сделать магазин более привлекательным для покупателей и увеличить продажи',
    },
    [DASHBOARD_TODO_LIST_FEATURE_HINT_IDS.COMPLETION_ICON]: {
        title: 'Отмечайте выполненные шаги',
        caption:
            'После завершения настройки отметьте шаг как выполненный — он исчезнет из списка активных и переместится в выполненные',
    },
    [DASHBOARD_TODO_LIST_FEATURE_HINT_IDS.NEW_LABEL]: {
        title: 'Появилась новая рекомендация',
        caption: 'Мы добавляем советы по мере настройки магазина и найденных точек роста',
    },
};
